import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import MapButton from '../../../Map';
import { FlexBox, PdfButton, RateComment, WorkInfo } from './style';
import { PDFDownloadLink } from '@react-pdf/renderer';
import DownloadPdf from 'components/DownloadPdf';

const WorkFooter = ({
  handleShowModal,
  data = {},
  objectsList = {},
  printTo,
}) => {
  const router = useLocation();
  const { users } = useSelector((state) => state.appReducer);

  const supervisorChecker = (id) => {
    if (id && users.length > 0) {
      const supervisorObj = users?.find((item) => item?._id === id);
      return `${supervisorObj?.lastName} ${supervisorObj?.firstName} ${supervisorObj.middleName}`;
    }
  };

  const actions = [
    {
      id: 0,
      label: 'Ташкилот номи:',
      value: data?.user?.organization?.title ?? '-',
      isBlue: false,
      show: true,
    },
    {
      id: 1,
      label: 'Дозарб этиб белгиланган кун:',
      value: data?.imDate ? moment(data?.imDate).format('DD.MM.YYYY') : '-',
      isBlue: false,
      show: data?.imDate ? true : false,
    },
    {
      id: 2,
      label: 'Назоратчи:',
      value: supervisorChecker(data?.supervisor) ?? '-',
      isBlue: false,
      show: supervisorChecker(data?.supervisor) ? true : false,
    },
    {
      id: 3,
      label: 'Бажарилган кун:',
      value: data?.createdAt
        ? moment(data?.createdAt).format('DD.MM.YYYY')
        : '-',
      isBlue: false,
      show: true,
    },
    {
      id: 7,
      label: 'Иштирокчилар сони',
      value: data?.public ? data?.public : 1,
      isBlue: false,
      show: true,
    },
    {
      id: 5,
      label: 'Бахоланган сана',
      value: data?.rateTime ? moment(data?.rateTime).format('DD.MM.YYYY') : '-',
      isBlue: false,
      show: data?.rateTime && true,
    },
    {
      id: 6,
      label: 'Модератор томонидан қўйилган балл',
      value: data?.rate,
      isBlue: true,
      show: data?.rateTime && true,
    },
  ];
  return (
    <>
      {data !== undefined ? (
        <WorkInfo>
          <FlexBox gap='0'>
            {actions.map(
              (action, index) =>
                action.show && (
                  <div key={`${index + 1}`} className='section'>
                    <span className='text'>{action.label}</span>
                    <span
                      className={`${action?.isBlue ? 'blueText' : ''} value`}
                    >
                      {action.value}
                    </span>
                  </div>
                )
            )}
            {router.pathname !== '/new-works' &&
              data?.objects &&
              data?.objects.length > 0 && (
                <div className='section'>
                  <div className='text'>Объект:</div>
                  <div className='value'>{data?.objects[0]?.title}</div>
                </div>
              )}
            <div className='section'>
              <span className='text'>Бажарилган иш жойини кўриш</span>
              <div className='value'>
                <MapButton noTitle smaller handleShowModal={handleShowModal} />
              </div>
            </div>
          </FlexBox>
          {data?.rate !== null && (
            <RateComment>
              <ul className='description'>
                {data?.rateComment?.length > 0 ? (
                  data?.rateComment
                    .split('/')
                    .map((rate, indx) => <li key={`${indx + 1}`}>{rate}</li>)
                ) : (
                  <span>Критериялар танланмаган...!</span>
                )}
              </ul>
            </RateComment>
          )}
          {printTo ? (
            <PdfButton>
              <PDFDownloadLink
                document={<DownloadPdf data={data} />}
                fileName={`${data.workId}.pdf`}
              >
                Юклаб олиш
              </PDFDownloadLink>
            </PdfButton>
          ) : null}
        </WorkInfo>
      ) : (
        <>No data</>
      )}
    </>
  );
};

export default React.memo(WorkFooter);
